import Vue from 'vue'
import App from './App.vue'
import './plugins/pp-vue-library'
import { Resizer } from 'sdk-widget-manager'
import PpVueAnalytics from 'pp-vue-analytics'
import { GA4_ID, GA_ID, GA4_PREFIX } from './constants/index'
import { datadogRum } from '@datadog/browser-rum'

Vue.use(Resizer)
Vue.config.productionTip = false

const params = new URLSearchParams(window.location.search)
const practiceGaId = params.get('gaId')
const isGA4Enabled = practiceGaId ?  practiceGaId.includes(GA4_PREFIX) : false
const category = window.Cypress ? 'contact-us-widget-cypress' : 'contact-us-widget'
const appGaId = isGA4Enabled ? GA4_ID : GA_ID

Vue.prototype.$isGA4Enabled = isGA4Enabled
Vue.prototype.$vuetify = {
  rtl: false,
  lang: {
    t: (val) => val
  },
  theme: {
    dark: false
  },
  breakpoint: {
    mobile: true,
    mobileBreakpoint: 600
  }
}

Vue.prototype.$ppColors = {
  primary: params.get('primary')
}

if (appGaId) {
  Vue.use(PpVueAnalytics, null, {
    appGaId,
    practiceGaId,
    category
  })
}

datadogRum.init({
  applicationId: '4798de18-6b47-4de8-8002-04b4dd63d549',
  clientToken: 'pub2c7a75cbd14088929463ad4a2acb0b7d',
  env: process.env.VUE_APP_STAGE,
  version: process.env.VUE_APP_VERSION,
  sampleRate: 100,
  site: 'datadoghq.com',
  service: 'contact-us-widget',
  useCrossSiteSessionCookie: true,
  trackInteractions: true,
  trackFrustrations: true,
  beforeSend: (event, context) => {
    // collect a RUM resource's response headers
    if (event.type === 'resource' && event.resource.type === 'fetch') {
      event.context = { ...event.context, responseHeaders: context.response.headers }
    }
  }
})

datadogRum.addRumGlobalContext('practiceUuid', params.get('practiceUuid'))

datadogRum.startSessionReplayRecording()

new Vue({
  render: h => h(App)
}).$mount('#app')
